import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { AddIcon, EditIcon } from "@kart/components";
import { toast } from "react-toastify";
import { SessionPopup } from "../components/SessionPopup";
import { useAxios } from "../hooks/useAxios";
import { useUser } from "../hooks/useUser";
import { calculateTimeFromMs } from "../utils/general.utils";
import {
  createNewSession,
  getAllSessionsForTrackAndUser,
} from "../utils/Session/Session.axios";
import { generateEmptySession } from "../utils/Session/session.utils";
import { Session } from "../utils/time/time.types";
import { Track } from "../utils/track/Track.types";

export const SessionOverview = () => {
  const { axios } = useAxios();
  const { user } = useUser();
  const location = useLocation<{ track: Track }>();
  const [sessions, setSessions] = useState<Session[]>();
  const [sessionToEdit, setSessionToEdit] = useState<Session>();

  useEffect(() => {
    if (!location.state?.track?.id || !user || !axios) return;
    getAllSessionsForTrackAndUser(axios, location.state.track.id, user.id).then(
      setSessions,
    );
  }, [location?.state?.track, user, axios]);

  const handleSubmit = (): void => {
    if (!axios) return;
    if (!sessionToEdit || !user) return;
    createNewSession(axios, { ...sessionToEdit, userId: user.id }).then(
      (createdSession) => {
        if (createdSession) {
          setSessionToEdit(undefined);
          toast("Session erfolgreich gespeichert");
        } else toast("Fehler beim speichern der Session");
      },
    );
  };
  return (
    <div className="session-page">
      {sessionToEdit && (
        <SessionPopup
          handleSubmit={handleSubmit}
          sessionToEdit={sessionToEdit}
          setSessionToEdit={setSessionToEdit}
        />
      )}
      <AddIcon
        className="session-page__add-icon"
        onClick={() =>
          setSessionToEdit(
            generateEmptySession({
              userId: user?.id,
              trackId: location.state?.track?.id,
            }),
          )
        }
      />
      <h1>Sessionübersicht</h1>
      <div>
        <p>{location.state?.track?.name}</p>
        <p>{location.state?.track?.location}</p>
        <p>
          Streckenrekord:{" "}
          {calculateTimeFromMs(location.state?.track?.lapRecord || 0)}s
        </p>
      </div>
      <div className="session-overview__sessions-wrapper">
        {sessions?.map((session) => (
          <div
            key={session.id}
            className="session-overview__sessions-wrapper__session-card"
          >
            <EditIcon
              className="session-overview__sessions-wrapper__session-card__icon"
              onClick={() => setSessionToEdit(session)}
            />
            <p className="session-overview__sessions-wrapper__session-card__paragraph">
              {session.name}
            </p>
            <p className="session-overview__sessions-wrapper__session-card__paragraph">
              Datum: {new Date(session.date).toLocaleDateString("DE-de")}
            </p>
            <p className="session-overview__sessions-wrapper__session-card__paragraph">
              Platzierung: {session.position}
            </p>
            <p className="session-overview__sessions-wrapper__session-card__paragraph">
              Teilnehmer: {session.competitors}
            </p>
            <p className="session-overview__sessions-wrapper__session-card__paragraph">
              Schnellste Runde: {calculateTimeFromMs(session.fastestLap)}s
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
